import { CALL_API } from "../../../middleware/api";
import * as ActionType from "../withdraw";
export function fetchCreateWithdraw(data, providerId) {
    var _a;
    return _a = {
            type: ActionType.CREATE_WITHDRAW
        },
        _a[CALL_API] = {
            endpoint: "/api/withdrawal/create?providerId=".concat(providerId),
            method: "PUT",
            types: [
                ActionType.SUCCESS_CREATE_WITHDRAW,
                ActionType.FAILURE_CREATE_WITHDRAW
            ],
            credentials: true,
            data: data
        },
        _a;
}
export function createWithdraw(data, providerId) {
    return function (dispatch) { return dispatch(fetchCreateWithdraw(data, providerId)); };
}
export function cancelWithdraw(data) {
    return function (dispatch) {
        var _a;
        return dispatch((_a = {
                type: ActionType.CANCEL_WITHDRAW
            },
            _a[CALL_API] = {
                endpoint: "/api/withdrawal/".concat(data),
                method: "DELETE",
                types: [
                    ActionType.SUCCESS_CANCEL_WITHDRAW,
                    ActionType.FAILURE_CANCEL_WITHDRAW
                ],
                credentials: true
            },
            _a));
    };
}
export function withdrawData() {
    return function (dispatch, getState) {
        var _a;
        var user = getState().auth.user;
        var accountResourceId = user.accountResourceId;
        var gamblerId = user.gamblerId;
        dispatch((_a = {
                type: ActionType.FETCH_WITHDRAW_DATA
            },
            _a[CALL_API] = {
                endpoint: "/api/withdrawal/data?accountResourceId=".concat(accountResourceId, "&gamblerId=").concat(gamblerId),
                method: "GET",
                types: [
                    ActionType.SUCCESS_FETCH_WITHDRAW_DATA,
                    ActionType.FAILURE_FETCH_WITHDRAW_DATA
                ],
                credentials: true
            },
            _a));
    };
}
export function fetchCryptoData(chain) {
    var _a;
    return _a = {
            type: ActionType.FETCH_CRYPTO_DATA
        },
        _a[CALL_API] = {
            endpoint: "/api/withdrawal/crypto/data?chain=".concat(chain),
            method: "GET",
            types: [
                ActionType.SUCCESS_FETCH_CRYPTO_DATA,
                ActionType.FAILURE_FETCH_CRYPTO_DATA
            ],
            credentials: true
        },
        _a;
}
export function clearWithdrawError() {
    return {
        type: ActionType.CLEAR_WITHDRAW_ERROR
    };
}



// WEBPACK FOOTER //
// ./src/actions/withdraw/creators/withdraw.js